<template>
  <div>
    <h4 class="text-h4">Tags</h4>
    <v-container>
      <draggable
        v-model="tagIds"
        :item-key="(i) => i"
        draggable=">*:not([data-locked='true'])"
        swapThreshold="0.6"
        fallbackTolerance="0"
        touchStartThreshold="3"
        :delay="isTouchDevice ? 150 : 0"
        :forceFallback="false"
        :delayOnTouchOnly="true"
        @add="bp_tagSortable.onAdd"
        @update="bp_tagSortable.onUpdate"
        data-test-id="draggable"
      >
        <template v-slot:item="{ element }">
          <TagItem :tagId="element" />
        </template>
      </draggable>
    </v-container>
  </div>
</template>

<script>
import TagItem from "./TagItem"

import draggable from "@/lib/draggable"
import { useTagSortable } from "../useTagSortable"

export default {
  name: "TagsList",
  components: {
    draggable,
    TagItem,
  },
  setup() {
    let bp_tagSortable = useTagSortable()

    return {
      isTouchDevice: window.__blinkplan_is_touch_device,
      tagIds: bp_tagSortable.tagIds,
      bp_tagSortable,
    }
  },
}
</script>

<style lang="scss" scoped></style>
